export default __webpack_public_path__ + "static/media/ep2collage2.925078e2.jpg";